var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "question",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-question-circle",
    "data-name": "Icon awesome-question-circle",
    d: "M20.563,10.563a10,10,0,1,1-10-10A10,10,0,0,1,20.563,10.563ZM10.831,3.869a5.223,5.223,0,0,0-4.7,2.571.485.485,0,0,0,.109.656l1.4,1.061a.484.484,0,0,0,.672-.086c.72-.914,1.214-1.443,2.311-1.443.824,0,1.843.53,1.843,1.329,0,.6-.5.914-1.312,1.37-.949.532-2.2,1.194-2.2,2.849v.161a.484.484,0,0,0,.484.484h2.258a.484.484,0,0,0,.484-.484v-.054c0-1.148,3.354-1.2,3.354-4.3C15.53,5.643,13.1,3.869,10.831,3.869Zm-.268,10a1.855,1.855,0,1,0,1.855,1.855A1.857,1.857,0,0,0,10.563,13.869Z",
    transform: "translate(-0.563 -0.563)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.da1a267755f0461ff9bd732e2dde3615.svg";
export { ForwardRef as ReactComponent };